import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const arcticWolf = defineConnector({
  identifier: "arcticWolf",
  name: "Arctic Wolf",
  tagLine: "Managed detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://protectapi\\.cylance\\.com/.*",
  auth: customAuth("arcticWolf"),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Arctic Wolf console, go to **Settings → Integrations** and create a new application. Copy the application ID, application secret, and tenant ID.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Tenant ID",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
        },
        {
          kind: "input",
          label: "Application ID",
          required: true,
          target: { kind: "secrets", field: "appId" },
        },
        {
          kind: "input",
          label: "Application secret",
          required: true,
          target: { kind: "secrets", field: "appSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://protectapi.cylance.com/devices/v2",
  },
});
